import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { apsViewModels } from "./dto/APS.ViewModels";
import { apsDisplayEnums } from "./dto/enums";
import {
    LineCounts, LineItem, LineJunctionItem
} from "../models/counts/lineCounts";

export interface ICountRow {
    isLine: boolean;
    line: LineItem;
    junction: LineJunctionItem;
    cssClass: string;
}

export interface ICountArea {
    rows: ICountRow[];
}

export interface IReportDate {
    Start: Date;
    End: Date;
}

export function mapLineToRow(line: LineItem): ICountRow {
    return {
        isLine: true,
        line: line,
        junction: null,
        cssClass: null
    };
}

export function mapJunctionToRow(junction: LineJunctionItem): ICountRow {
    return {
        isLine: false,
        line: null,
        junction: junction,
        cssClass: 'table' + (junction.inputs.length > junction.outputs.length
            ? junction.inputs.length : junction.outputs.length).toString()
    };
}

export function mapModelToAreas(model: LineCounts): ICountArea[] {
    let areas = [];
    let area: ICountArea = {
        rows: _.sortBy(model.lines.filter(l => l.startJunctionId === null), r => r.number)
            .map(l => mapLineToRow(l))
    };

    while (area.rows.length > 0) {
        areas.push(area);

        let previousLines = area.rows.filter(l => l.isLine).map(l => l.line);
        let rows = [];
        area.rows.forEach(row => {

            // if row is junction, add all of the output lines
            if (!row.isLine) {
                _.sortBy(row.junction.outputs, l => l.number).forEach(line => {
                    rows.push(mapLineToRow(line));
                });
                return;
            }

            let junction = row.line.endJunction;
            if (!junction) {
                return;
            }

            // do not add the junction if it is already in the list of rows
            if (_.some(rows, r => !r.isLine && r.junction === junction)) {
                return;
            }

            // if the end junction references lines not in the previous area, add the line instead
            if (!junction.inputs.every(l => _.some(previousLines, al => al.id === l.id))) {
                rows.push(mapLineToRow(row.line));
            }

            rows.push(mapJunctionToRow(junction));
        });

        area = { rows: rows };
    }
    return areas;
}

export function getReportDate(
    shopConfig: apsViewModels.ShopConfigurationWithShifts, 
    countsInterval: apsDisplayEnums.CountDisplayInterval): IReportDate {
    
    let endDate = moment().toDate();
    let now = moment();
    let remainderMinutes = now.minute() % 10;
    let remainderSeconds = now.second();
    let remainderMilliSeconds = now.millisecond();

    let reportDate: IReportDate = {
        Start: null,
        End: endDate
    };

    switch (countsInterval) {
        case apsDisplayEnums.CountDisplayInterval.CurrentHour:
            reportDate.Start = moment().startOf('hour').toDate();
            break;
        case apsDisplayEnums.CountDisplayInterval.PreviousHour:
            reportDate.End = moment().startOf('hour').toDate();
            reportDate.Start = moment(reportDate.End).subtract(1, 'hour').toDate();
            break;
        case apsDisplayEnums.CountDisplayInterval.CurrentShift:
            reportDate.Start = shopConfig.shiftsInLast24Hours[0].startTime;
            break;
        case apsDisplayEnums.CountDisplayInterval.LastShift:
            reportDate.End = shopConfig.shiftsInLast24Hours[1].stopTime;
            reportDate.Start = shopConfig.shiftsInLast24Hours[1].startTime;
            break;
        case apsDisplayEnums.CountDisplayInterval.ShiftBeforeLast:
            reportDate.End = shopConfig.shiftsInLast24Hours[2].stopTime;
            reportDate.Start = shopConfig.shiftsInLast24Hours[2].startTime;
            break;
        case apsDisplayEnums.CountDisplayInterval.RollingHour:
            reportDate.End = moment(now)
              .subtract(remainderMinutes, 'minute')
              .subtract(remainderSeconds, 'second')
              .subtract(remainderMilliSeconds, 'millisecond')
              .toDate();
            reportDate.Start = moment(reportDate.End)
              .subtract(1, 'hour')
              .toDate();
            break;
        case apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes:
            reportDate.End = moment(now)
              .subtract(remainderMinutes, 'minute')
              .subtract(remainderSeconds, 'second')
              .subtract(remainderMilliSeconds, 'millisecond')
              .toDate();
            reportDate.Start = moment(reportDate.End)
              .subtract(20, 'minute')
              .toDate();
            break;
        default: // default to 24 hours
            reportDate.End = moment().startOf('hour').toDate();
            reportDate.Start = moment(reportDate.End).subtract(1, 'days').toDate();
            break;
    }

    return reportDate;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/shared/mapping.functions.ts